import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { IconMapPin, IconCalendar, IconBell } from './Icons';
import './Features.css';

const Features = () => {
  const { t } = useTranslation();
  const [sectionRef, isVisible] = useScrollReveal();

  const steps = [
    { num: 1, titleKey: 'howItWorksStep1Title', descKey: 'howItWorksStep1Description', Icon: IconMapPin },
    { num: 2, titleKey: 'howItWorksStep2Title', descKey: 'howItWorksStep2Description', Icon: IconCalendar },
    { num: 3, titleKey: 'howItWorksStep3Title', descKey: 'howItWorksStep3Description', Icon: IconBell },
  ];

  const renderIcon = (type) => {
    const icons = {
      calendar: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
      ),
      team: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <circle cx="9" cy="7" r="3" /><circle cx="17" cy="9" r="2.5" />
          <path d="M3 20c0-3 2.5-5 6-5s6 2 6 5M14 20c0-2 1.5-3.5 4-3.5" />
        </svg>
      ),
      megaphone: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M4 10v4M7 8l11-4v16l-11-4H5a1 1 0 01-1-1v-6a1 1 0 011-1h2z" />
        </svg>
      ),
      chart: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M4 19V5M4 19h16M8 15V9M12 15V7M16 15v-3" />
        </svg>
      ),
      bell: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7M13.7 21a2 2 0 01-3.4 0" />
        </svg>
      ),
      star: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7l3-7z" />
        </svg>
      ),
    };
    return icons[type] || icons.calendar;
  };

  return (
    <section id="features" className="features how-it-works" aria-label="How it works" ref={sectionRef}>
      <div className="container">
        <h2 className={`section-title reveal-up ${isVisible ? 'revealed' : ''}`}>{t('whatWeDo')}</h2>
        <p className={`section-subtitle how-it-works-subtitle reveal-up ${isVisible ? 'revealed' : ''}`}>
          {t('whatWeDoDescription')}
        </p>
        <div className="how-it-works-content">
          <div className="how-it-works-steps">
            {steps.map((step, index) => {
              const StepIcon = step.Icon;
              return (
                <div
                  key={step.num}
                  className={`how-it-works-step reveal-up ${isVisible ? 'revealed' : ''}`}
                  style={{ '--reveal-delay': `${index * 0.1}s` }}
                >
                  <span className="how-it-works-step-icon" aria-hidden="true">
                    <StepIcon />
                  </span>
                  <div className="how-it-works-step-body">
                    <h3 className="how-it-works-step-title">{t(step.titleKey)}</h3>
                    <p className="how-it-works-step-desc">{t(step.descKey)}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
